import * as types from '../constants/ActionTypes'
import { mergeDeepRight } from 'ramda';

const publicChannels = (state = {}, action) => {
  switch (action.type) {
    case types.GET_PUBLIC_CHANNELS_SUCCESS:
      if (action.payload && action.payload.publicChannels) {
        return action.payload.publicChannels;
      }
      return state;
    case types.START_PUBLIC_CHANNEL :
      return state ? mergeDeepRight(state, action.payload) : action.payload;
    default:
      return state;
  }
};

export default publicChannels;
